import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col gap-20" }
const _hoisted_2 = {
  key: 0,
  class: "row mleft-02 w-full"
}
const _hoisted_3 = { class: "h4" }
const _hoisted_4 = { class: "item-modal" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col mtop-04" }
const _hoisted_8 = { class: "bg-modal w-maxC" }
const _hoisted_9 = { class: "col mtop-02" }
const _hoisted_10 = { class: "avg-width" }
const _hoisted_11 = { class: "avg-width" }
const _hoisted_12 = {
  key: 0,
  class: "pad-s row psides-02"
}
const _hoisted_13 = { class: "main-l font-m mleft-auto" }
const _hoisted_14 = { class: "bg-modal w-maxC" }
const _hoisted_15 = { class: "col mtop-02" }
const _hoisted_16 = { class: "avg-width" }
const _hoisted_17 = { class: "avg-width" }
const _hoisted_18 = {
  key: 0,
  class: "pad-s row psides-02"
}
const _hoisted_19 = { class: "main-l font-m mleft-auto top-spacing" }
const _hoisted_20 = { class: "bg-modal" }
const _hoisted_21 = { class: "col mtop-02" }
const _hoisted_22 = {
  key: 0,
  class: "main-l font-m mleft-auto"
}

import { ref, computed, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAppUserStore } from '@/stores/appUser';
import editTaskBoxCustom from './editTaskBoxCustom.vue';
import addTaskBoxDirect from './addTaskBoxDirect.vue';
import editTask from '@/views/officeMain/tasks/editTask.vue';
import { toastError, toastSuccess, toastInfo } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import gen from '@/functions/general.js';
import { getTaskBoxIcon, getTaskBoxTitle } from '@/functions/office';
import officeapi from '@/api/officeapi';
import { TaskApi, TaskBoxesParticipantsResponse, TaskBoxesResponse } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';


export default /*@__PURE__*/_defineComponent({
  __name: 'taskBoxColumn',
  props: {
  task: {
    type: Object,
    required: false,
  },
  showMessageCount: {
    type: Boolean,
    default: false,
  },
  showTaskBoxSettings: {
    type: Boolean,
    default: false,
  },
  hasPatientOptions: {
    type: Boolean,
    default: false,
  },
  isMainMenu: {
    type: Boolean,
    default: false
  },
  startTaskBox: {
    type: String,
    required: false,
  },
},
  emits: ['changeTaskBox', 'reload', 'afterDeactivateTaskBox'],
  setup(__props, { emit: __emit }) {

const appUserStore = useAppUserStore();
const toast = useToast();
const { t } = useI18n();

const emits = __emit;
const props = __props;

const taskApi = new TaskApi(medServerApiConfig);
const taskBoxParticipant = ref<TaskBoxesParticipantsResponse>(undefined);
const dropd = ref("");

function getInitialTaskBoxId() {
  //Start TaskBox
  if (props.startTaskBox) return props.startTaskBox;

  //If task
  if (props.task) {
    return props.task.taskBox
      ? props.task.taskBox.taskBoxId
      : props.task.patientNoteType;
  }
  //Ret
  return "";
}

const currTaskBoxId =  ref(getInitialTaskBoxId())
const currTaskBox = computed(() => {
  return appUserStore.taskBoxList.find(tb => tb.taskBoxId == currTaskBoxId.value) || null
})

const taskBoxStored = computed(() => {
  return appUserStore.taskBoxList;
})

function getIcon(taskBox: any) {
  return getTaskBoxIcon(taskBox);
}

async function importFilesChangedFCT(files: FileList, taskBox: any) {
  const taskBoxId = taskBox.taskBoxId;
  await officeapi.addImportFilesAsTasks(taskBoxId, files);
  emits('reload');
}

const sleep = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function importMixedFiles(files) {
  const filesArray = Array.from(files);
  // Group files by base name (without extension)
  const fileGroups = new Map();
  filesArray.forEach(file => {
    const lastDotIndex = file.name.lastIndexOf('.');
    const baseName = lastDotIndex > 0 ? file.name.substring(0, lastDotIndex) : file.name;
    if (!fileGroups.has(baseName)) {
      fileGroups.set(baseName, []);
    }
    fileGroups.get(baseName).push(file);
  });
  // Find all files without corresponding XML
  const filesWithoutXml = [];
  for (const [baseName, groupFiles] of fileGroups.entries()) {
    const xmlFile = groupFiles.find(file => file.name.endsWith('.xml'));
    if (!xmlFile) {
      // This group has no XML file, add all files from this group
      filesWithoutXml.push(...groupFiles);
    }
  }
  // If there are files without XML, log them and stop
  if (filesWithoutXml.length > 0) {
    const unprocessedFilesMsg = filesWithoutXml.map(file => " - " + file.name).join("\n");
    toastError(toast, {
      summary: t('task.import.regibox.message.missingXmlData'),
      detail: (unprocessedFilesMsg)
    });    
    return; // Don't process anything
  }
  // Only proceed if all files have corresponding XML
  const sortedFiles = [];
  for (const [baseName, groupFiles] of fileGroups.entries()) {
    // Sort each group to have XML first
    const sortedGroup = groupFiles.sort((a, b) => {
      if (a.name.endsWith('.xml')) return -1;
      if (b.name.endsWith('.xml')) return 1;
      return 0;
    });
    
    // Add sorted group to flat array
    sortedFiles.push(...sortedGroup);
  }
  toastSuccess(toast, {
    summary: t('task.import.regibox.message.startImport.summary'),
    detail:  t('task.import.regibox.message.startImport.detail', {fileNumber: fileGroups.size})
  });
  for (const [baseName, groupFiles]  of fileGroups) {
    const result = await officeapi.autoImportXmlFiles(groupFiles);
    const hasErrors = result.errors && result.errors.length > 0;
    toastInfo(toast, {
      summary: t('task.import.regibox.message.endImport.summary'),
      detail: t('task.import.regibox.message.endImport.detail', {
        total: result.totalFiles,
        successful: result.successfulImports,
        tasksCreated: result.tasksCreated,
        failed: result.failedImports,
        errors: hasErrors ? result.errors.join('\n') : ''
      })
    });
    sleep(1000);
  }

  emits('reload');
}

function reload() {
  emits('reload');
}

function changeTaskBoxToPatient(keyword: string) {
  currTaskBoxId.value = keyword;
  emits('changeTaskBox', keyword);
}

function afterDeactivateTaskBox() {
  currTaskBoxId.value = "";
  emits('afterDeactivateTaskBox');
}
const changeTaskBox = async(clickedTaskBoxId: any, isTwoPerson: boolean) => {
  const newTaskBoxId = props.isMainMenu && clickedTaskBoxId === currTaskBoxId.value 
    ? "" 
    : clickedTaskBoxId;
  currTaskBoxId.value = newTaskBoxId;

  if (props.isMainMenu && !isTwoPerson) {
    await getTaskBoxParticipants(); 
  }
  
  emits('changeTaskBox', newTaskBoxId);
}

const getTaskBoxParticipants = async () => {
  if (currTaskBoxId.value) {
    taskApi.getParticipantsByTaskBox({taskBoxId: currTaskBoxId.value}).then((taskBoxesResponse: TaskBoxesParticipantsResponse) => {
      taskBoxParticipant.value = taskBoxesResponse;
    });
  }
}

function openAddTaskBoxDirect() {
  dropd.value = "addTaskBoxDirect";
}

function createTaskBoxFilter(taskBox: any) {
  const creatorName = taskBox.isCreator ? "" : (taskBox.pwrTaskBoxCreator?.lastName ? taskBox.pwrTaskBoxCreator.lastName : "");
  return {
    "key": taskBox.taskBoxId,
    "text": taskBox.taskBoxTitle,
    "creator": creatorName,
    "taskBox": taskBox,
  }
}

function createTwoPersonTaskBoxFilter(taskBox: any) {
  const taskBoxList = appUserStore.taskBoxList
  const taskBoxTitle = getTaskBoxTitle(taskBox, taskBoxList, appUserStore.currentHealthGroupMembership.pwr)
  return {
    "key": taskBox.taskBoxId,
    "text": taskBoxTitle,
    "taskBox": taskBox,
  }
}

const assigneeFilterList = ref<TaskBoxesResponse[]>([])
const nonAssigneeFilterList = ref<TaskBoxesResponse[]>([])
const twoPersonFilterList = ref<TaskBoxesResponse[]>([])

function updateTaskBoxFilters() {
  assigneeFilterList.value = []
  nonAssigneeFilterList.value = []
  twoPersonFilterList.value = []

  //Create Filters
  const assigneeFilters = appUserStore.taskBoxAssigneeList.map(taskBox =>
    createTaskBoxFilter(taskBox)
  )
  const nonAssigneeFilters = appUserStore.taskBoxNonAssigneeList.map(taskBox =>
    createTaskBoxFilter(taskBox)
  )
  const twoPersonFilters = appUserStore.taskBoxTwoPersonList.map(taskBox =>
    createTwoPersonTaskBoxFilter(taskBox)
  )

  //Count
  if (appUserStore.taskList) {
    appUserStore.taskList.forEach((task) => {
      let taskBoxFilter = assigneeFilters.find((filter) => filter.key == task.taskBox.taskBoxId)
        || nonAssigneeFilters.find((filter) => filter.key == task.taskBox.taskBoxId)
        || twoPersonFilters.find((filter) => filter.key == task.taskBox.taskBoxId)
      if (!taskBoxFilter) return;
    })
  }

  //Fill
  assigneeFilterList.value = assigneeFilters.sort((a, b) => a.text.localeCompare(b.text));
  nonAssigneeFilterList.value = nonAssigneeFilters.sort((a, b) => a.text.localeCompare(b.text));
  twoPersonFilterList.value = twoPersonFilters.sort((a, b) => a.text.localeCompare(b.text));
}

const newChatHealthGroups = computed(() => {
  if (!appUserStore.currentAppUserData) return [];
  let ret = gen.deepCopy(appUserStore.currentAppUserData.healthGroupMemberships)

  //Get filter criteria
  const pwrAppUser = appUserStore.currentHealthGroupMembership.pwr
  const existingPwrIds = appUserStore.taskBoxTwoPersonList.flatMap(taskBox => {
    const fullTaskBox = appUserStore.taskBoxList.find(tb => tb.taskBoxId == taskBox.taskBoxId)
    return fullTaskBox?.pwrParticipants ? fullTaskBox.pwrParticipants?.map(pwrParticipant => pwrParticipant.personWithRoleId) : [];
  })

  //Filter
  ret.forEach(relationShip => {
    relationShip.healthGroupMembers = relationShip.healthGroupMembers
      .filter(member => member.pwr.personWithRoleId !== pwrAppUser.personWithRoleId)  //filter out self
      .filter(member => !existingPwrIds.includes(member.pwr.personWithRoleId))        //Filter out existing ones
  })

  return ret
})

const hasNewChatPeople = computed(() => {
  return newChatHealthGroups.value.some(rel => rel.healthGroupMembers.length > 0)
})

const getTaskBoxesList = async () => {
  await taskApi.getTaskBoxes({justTwoPersonChannel: false}).then((result: TaskBoxesResponse[]) => {
    appUserStore.setTaskBoxByAssigneeValue(result);
  });

  await taskApi.getTaskBoxes({justTwoPersonChannel: true}).then((result: TaskBoxesResponse[]) => {
    appUserStore.setTaskBoxTwoPerson(result);
  });
}

watch(
  () => [
    appUserStore.taskList,
  ],
  () => {
    updateTaskBoxFilters()
  },
  { immediate: true }
)

watch (taskBoxStored.value,
  () => {
    updateTaskBoxFilters();
  }
  
)

onMounted(async () => {
 if (!appUserStore.taskBoxList.length) {
    await getTaskBoxesList();
  }
})


return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_itemModal = _resolveComponent("itemModal")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_file_upload = _resolveComponent("file-upload")!
  const _component_switchGroup = _resolveComponent("switchGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_list_group = _resolveComponent("list-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isMainMenu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('task.mainTitle')), 1),
          _createVNode(_component_itemModal, { uiId: "addNewTaskFromDashb" }, {
            modal: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(editTask, {
                  startTaskBox: currTaskBox.value?.taskBoxId || currTaskBox.value,
                  onChanged: _cache[0] || (_cache[0] = ($event: any) => (reload()))
                }, null, 8, ["startTaskBox"])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, { class: "mleft-02" }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "plus",
                    styles: "main-m size-l"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_file_upload, {
            id: 'importFilesGeneral' + currTaskBoxId.value,
            multiple: "",
            directory: "",
            flatOnly: "",
            onFilesChanged: importMixedFiles,
            class: "mleft-auto"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, {
                class: "psides-06 border-l",
                styles: "pad-s psides-06"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "upload",
                    styles: "main-m size-s"
                  }),
                  _createVNode(_component_text_item, {
                    txt: "Regibox",
                    styles: "main-m",
                    class: "mleft-04"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["id"])
        ]))
      : _createCommentVNode("", true),
    (props.hasPatientOptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_text_item, {
              txt: "Patient",
              styles: "font-mBold"
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_switchGroup, {
              active: ['Healthcare', 'Administrative'].includes(currTaskBoxId.value),
              class: "w-full rowcenter w-maxC",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTaskBoxToPatient('Healthcare')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('settings.params.tasks.patientnote'),
                  styles: "main-m",
                  style: {"max-width":"8rem"},
                  class: _normalizeClass(['Healthcare', 'Administrative'].includes(currTaskBoxId.value) ? 'txt-white' : 'patient-note-max-w')
                }, null, 8, ["txt", "class"])
              ]),
              _: 1
            }, 8, ["active"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_dropdownBox, {
        modelValue: dropd.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dropd).value = $event)),
        openOn: "addTaskBoxAssignee"
      }, {
        dropd: _withCtx(() => [
          _createVNode(editTaskBoxCustom, {
            "is-assignee": true,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (dropd.value = '')),
            taskBoxParticipant: taskBoxParticipant.value,
            onAfterDeactivateTaskBox: _cache[3] || (_cache[3] = ($event: any) => (afterDeactivateTaskBox())),
            onRefreshParticipant: _cache[4] || (_cache[4] = ($event: any) => (getTaskBoxParticipants()))
          }, null, 8, ["taskBoxParticipant"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_dropdownBox, {
        modelValue: dropd.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dropd).value = $event)),
        openOn: "menuTaskBoxAssignee"
      }, {
        dropd: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_list_group, {
              class: "w-full gap-04 psides-04",
              styles: "pad-s",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (dropd.value = 'addTaskBoxAssignee'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, { icon: "plus" }),
                _createVNode(_component_text_item, {
                  txt: _unref(t)('task.taskBoxCustomMenu.addTaskBox')
                }, null, 8, ["txt"])
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('task.myMissionsTitle'),
                styles: "font-mBold"
              }, null, 8, ["txt"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assigneeFilterList.value, (filter, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (__props.isMainMenu || __props.task || filter.taskBox.taskBoxChannelType !== 'Results')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["row", props.showTaskBoxSettings ? 'switch-full-max-w' : 'switch-max-w'])
                }, [
                  _createVNode(_component_switchGroup, {
                    active: filter.key === currTaskBoxId.value,
                    class: "w-full rowcenter",
                    style: {"width":"max-content"},
                    onClick: ($event: any) => (changeTaskBox(filter.key, false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_item, {
                        icon: getIcon(filter.taskBox),
                        styles: "main-m",
                        class: _normalizeClass(filter.key === currTaskBoxId.value ? 'img-white' : '')
                      }, null, 8, ["icon", "class"]),
                      _createVNode(_component_text_item, {
                        txt: filter.text,
                        class: _normalizeClass(["mleft-06 taskBoxName-max-w", filter.key === currTaskBoxId.value ? 'txt-white' : '']),
                        styles: "main-m"
                      }, null, 8, ["txt", "class"]),
                      (filter.creator)
                        ? (_openBlock(), _createBlock(_component_text_item, {
                            key: 0,
                            txt: filter.creator,
                            class: _normalizeClass(["mleft-04 creator-max-w", filter.key === currTaskBoxId.value ? 'txt-white' : '']),
                            styles: "main-l font-s"
                          }, null, 8, ["txt", "class"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["active", "onClick"]),
                  (filter.taskBox.taskBoxChannelType === 'Results' && props.isMainMenu)
                    ? (_openBlock(), _createBlock(_component_file_upload, {
                        key: 0,
                        id: 'importFilesOnDropZone' + currTaskBoxId.value,
                        multiple: "",
                        onFilesChanged: (files) => importFilesChangedFCT(files, filter.taskBox)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_buttonGroup, {
                            class: "mleft-01 psides-06",
                            styles: "pad-l"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, {
                                icon: "upload",
                                styles: "main-m size-s",
                                style: {"margin-top":"-0.5rem"}
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["id", "onFilesChanged"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    (props.showTaskBoxSettings && filter.key === currTaskBoxId.value)
                      ? (_openBlock(), _createBlock(_component_dropdownBox, {
                          key: 0,
                          modelValue: dropd.value,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dropd).value = $event)),
                          openOn: "editTaskBoxCustomAssignee"
                        }, {
                          dropd: _withCtx(() => [
                            _createVNode(editTaskBoxCustom, {
                              taskBox: filter.taskBox,
                              taskBoxParticipant: taskBoxParticipant.value,
                              onClose: _cache[8] || (_cache[8] = ($event: any) => (dropd.value = '')),
                              onAfterDeactivateTaskBox: _cache[9] || (_cache[9] = ($event: any) => (afterDeactivateTaskBox())),
                              onRefreshParticipant: _cache[10] || (_cache[10] = ($event: any) => (getTaskBoxParticipants()))
                            }, null, 8, ["taskBox", "taskBoxParticipant"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_buttonGroup, { class: "pad-s psides-06" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_svg_item, {
                                  icon: "settings",
                                  styles: "main-l",
                                  style: {"margin-top":"-0.1rem"}
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mleft-auto thin-w" }, null, -1)),
                  _createElementVNode("div", _hoisted_11, [
                    (props.showMessageCount && filter.taskBox.totalTask)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(filter.taskBox.totalTask), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_dropdownBox, {
        modelValue: dropd.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dropd).value = $event)),
        openOn: "addTaskBoxNonAssignee"
      }, {
        dropd: _withCtx(() => [
          _createVNode(editTaskBoxCustom, {
            "is-assignee": false,
            onClose: _cache[12] || (_cache[12] = ($event: any) => (dropd.value = '')),
            taskBoxParticipant: taskBoxParticipant.value,
            onAfterDeactivateTaskBox: _cache[13] || (_cache[13] = ($event: any) => (afterDeactivateTaskBox())),
            onRefreshParticipant: _cache[14] || (_cache[14] = ($event: any) => (getTaskBoxParticipants()))
          }, null, 8, ["taskBoxParticipant"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_dropdownBox, {
        modelValue: dropd.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((dropd).value = $event)),
        openOn: "menuTaskBoxNonAssignee"
      }, {
        dropd: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_list_group, {
              class: "w-full gap-04 psides-04",
              styles: "pad-s",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (dropd.value = 'addTaskBoxNonAssignee'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, { icon: "plus" }),
                _createVNode(_component_text_item, {
                  txt: _unref(t)('task.taskBoxCustomMenu.addTaskBox')
                }, null, 8, ["txt"])
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('task.assignedMissionsTitle'),
                styles: "font-mBold"
              }, null, 8, ["txt"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nonAssigneeFilterList.value, (filter, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (props.isMainMenu || props.task || filter.taskBox.taskBoxChannelType !== 'Results')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["row", props.showTaskBoxSettings ? 'switch-full-max-w' : 'switch-max-w'])
                }, [
                  _createVNode(_component_switchGroup, {
                    active: filter.key === currTaskBoxId.value,
                    class: "row w-maxC",
                    onClick: ($event: any) => (changeTaskBox(filter.key, false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_item, {
                        icon: getIcon(filter.taskBox),
                        styles: "main-m",
                        class: _normalizeClass(filter.key === currTaskBoxId.value ? 'img-white' : '')
                      }, null, 8, ["icon", "class"]),
                      _createVNode(_component_text_item, {
                        txt: filter.text,
                        class: _normalizeClass(["mleft-06 taskBoxName-max-w", filter.key === currTaskBoxId.value ? 'txt-white' : '']),
                        styles: "main-m"
                      }, null, 8, ["txt", "class"]),
                      (filter.creator)
                        ? (_openBlock(), _createBlock(_component_text_item, {
                            key: 0,
                            txt: filter.creator,
                            class: _normalizeClass(["mleft-04 creator-max-w", filter.key === currTaskBoxId.value ? 'txt-white' : '']),
                            styles: "main-l font-s"
                          }, null, 8, ["txt", "class"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["active", "onClick"]),
                  (filter.taskBox.taskBoxChannelType === 'Results' && props.isMainMenu)
                    ? (_openBlock(), _createBlock(_component_file_upload, {
                        key: 0,
                        id: 'importFiles' + currTaskBoxId.value,
                        multiple: "",
                        onFilesChanged: (files) => importFilesChangedFCT(files, filter.taskBox)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_buttonGroup, {
                            class: "mleft-01 psides-06",
                            styles: "pad-l"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, {
                                icon: "upload",
                                styles: "main-m size-s",
                                style: {"margin-top":"-0.5rem"}
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["id", "onFilesChanged"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_16, [
                    (props.showTaskBoxSettings && filter.key === currTaskBoxId.value)
                      ? (_openBlock(), _createBlock(_component_dropdownBox, {
                          key: 0,
                          modelValue: dropd.value,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((dropd).value = $event)),
                          openOn: "editTaskBoxCustomNonAssignee"
                        }, {
                          dropd: _withCtx(() => [
                            _createVNode(editTaskBoxCustom, {
                              taskBox: filter.taskBox,
                              taskBoxParticipant: taskBoxParticipant.value,
                              onClose: _cache[18] || (_cache[18] = ($event: any) => (dropd.value = '')),
                              onAfterDeactivateTaskBox: _cache[19] || (_cache[19] = ($event: any) => (afterDeactivateTaskBox())),
                              onRefreshParticipant: _cache[20] || (_cache[20] = ($event: any) => (getTaskBoxParticipants()))
                            }, null, 8, ["taskBox", "taskBoxParticipant"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_buttonGroup, { class: "pad-s psides-06 mleft-02" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_svg_item, {
                                  icon: "settings",
                                  styles: "main-l",
                                  style: {"margin-top":"-0.1rem"}
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mleft-auto thin-w" }, null, -1)),
                  _createElementVNode("div", _hoisted_17, [
                    (props.showMessageCount && filter.taskBox.totalTask)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(filter.taskBox.totalTask), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("div", null, [
      (hasNewChatPeople.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((dropd).value = $event)),
              openOn: "addTaskBoxDirect"
            }, {
              dropd: _withCtx(() => [
                _createVNode(addTaskBoxDirect, {
                  healthGroupMemberships: newChatHealthGroups.value,
                  onClose: _cache[22] || (_cache[22] = ($event: any) => (dropd.value = ''))
                }, null, 8, ["healthGroupMemberships"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((dropd).value = $event)),
              openOn: "menuTaskBoxDirect"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  (hasNewChatPeople.value)
                    ? (_openBlock(), _createBlock(_component_list_group, {
                        key: 0,
                        class: "w-full gap-04 psides-04",
                        styles: "pad-s",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (openAddTaskBoxDirect()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_item, { icon: "plus" }),
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('task.twoPersonMenu.addTaskBox')
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { theme: "dropdown" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('task.twoPersonTitle'),
                      styles: "font-mBold"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
        : (_openBlock(), _createBlock(_component_text_item, {
            key: 1,
            txt: _unref(t)('task.twoPersonTitle'),
            styles: "font-mBold",
            class: "pad-m"
          }, null, 8, ["txt"])),
      _createElementVNode("div", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(twoPersonFilterList.value, (filter, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "row",
            style: {"width":"13.5rem"}
          }, [
            _createVNode(_component_switchGroup, {
              active: filter.key === currTaskBoxId.value,
              class: "w-full rowcenter",
              style: {"width":"max-content"},
              onClick: ($event: any) => (changeTaskBox(filter.key, true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: filter.text,
                  styles: "main-m",
                  style: {"max-width":"8rem","margin-top":"-0.1rem"},
                  class: _normalizeClass(filter.key === currTaskBoxId.value ? 'txt-white' : '')
                }, null, 8, ["txt", "class"])
              ]),
              _: 2
            }, 1032, ["active", "onClick"]),
            (props.showMessageCount && filter.taskBox.totalTask)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(filter.taskBox.totalTask), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})